/**
 * Routes cv — gestion multi-CV.
 *
 * @remarks
 * - Zone `authenticated` (login requis) : la liste « Mes CV » et l'édition d'un
 *   CV (adéquation + grille de compétences), scopées par `:cvId` (id de document).
 * - Zone `public-bare` : la page CV publique partageable (`/cv/:token`), hors shell.
 *
 * Pas de collision : `/cv` (profondeur 1), `/cv/:token` (profondeur 2, public-bare),
 * `/cv/:cvId/edit|skills` (profondeur 3, authenticated) sont distincts.
 * `Component: Outlet` sur les leaves authenticated : l'AppShell rend via le registry.
 */

import { lazy } from 'react';
import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

const CvPublicView = lazy(() =>
  import('./views/CvPublicView/CvPublicView').then((m) => ({ default: m.CvPublicView })),
);

const PublicAnalysisView = lazy(() =>
  import('./views/CvPublicView/PublicAnalysisView').then((m) => ({
    default: m.PublicAnalysisView,
  })),
);

export const cvAuthenticatedRoutes: RouteObject[] = [
  {
    path: 'cv',
    Component: Outlet,
    handle: { context: CONTEXTS.CV_LIST, title: 'Mes CV' },
  },
  {
    path: 'cv/:cvId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.CV, title: "CV d'adéquation" },
  },
  {
    path: 'cv/:cvId/skills',
    Component: Outlet,
    handle: { context: CONTEXTS.CV_SKILLS, title: 'Grille de compétences' },
  },
];

/**
 * Route standalone (zone 'public-bare') — page CV éditoriale, hors shell.
 * `:token` = jeton de partage opaque. La vue résout le CV via
 * `GET /api/public/cvs/:token` (non authentifié) et rend le snapshot du rapport.
 */
export const cvBareRoutes: RouteObject[] = [
  {
    path: 'cv/:token',
    element: <CvPublicView />,
    handle: { title: 'CV Professionnel' },
  },
  {
    path: 'cv/:token/analyse',
    element: <PublicAnalysisView />,
    handle: { title: 'Analyse complète' },
  },
];
